// USER
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'
export const USER_LOGIN_LOADING = 'USER_LOGIN_LOADING'
export const USER_LOGIN_RESET = 'USER_LOGIN_RESET'
export const USER_LOGIN_ERROR_RESET = 'USER_LOGIN_ERROR_RESET'
export const USER_TOKEN_REFRESH_SUCCESS = 'USER_TOKEN_REFRESH_SUCCESS'
export const GET_PROFILE_DATA_SUCCESS = 'GET_PROFILE_DATA_SUCCESS'
export const GET_ACCOUNT_BALANCE_SUCCESS = 'GET_ACCOUNT_BALANCE_SUCCESS'
export const GET_ACCOUNT_BALANCE_LOADING = 'GET_ACCOUNT_BALANCE_LOADING'
export const GET_ACCOUNT_BALANCE_ERROR = 'GET_ACCOUNT_BALANCE_ERROR'

export const GET_ME_LOADING = 'GET_ME_LOADING'
export const GET_ME_SUCCESS = 'GET_ME_SUCCESS'

// MENU
export const SELECT_MENU_ITEM = 'SELECT_MENU_ITEM'

// SETTINGS
export const CHANGE_LOCALE = 'CHANGE_LOCALE'
export const SHOW_LOCALE_MODAL = 'SHOW_LOCALE_MODAL'
export const CLOSE_LOCALE_MODAL = 'CLOSE_LOCALE_MODAL'

// PARTNER
export const PARTNER_FETCH_SUCCESS = 'PARTNER_FETCH_SUCCESS'
export const PARTNER_FAIL = 'PARTNER_FAIL'
export const PARTNER_LOADING = 'PARTNER_LOADING'

// GOALS
export const SKIP_GOAL_SETTING = 'SKIP_GOAL_SETTING'
export const GET_CURRENT_GOAL_DATA_SUCCESS = 'GET_CURRENT_GOAL_DATA_SUCCESS'

// NOTIFICATIONS
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS'
export const SET_NOTIFICATION_READ = 'SET_NOTIFICATION_READ'

// SUPPORT CHAT
export const SHOW_SUPPORT_CHAT = 'SHOW_SUPPORT_CHAT'
export const HIDE_SUPPORT_CHAT = 'HIDE_SUPPORT_CHAT'
export const SUPPORT_CHAT_IS_READY = 'SUPPORT_CHAT_IS_READY'
